import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { supabase } from "../supabaseClient";
import YildizArkaplan from "../components/YildizArkaplan";
import { FALCILAR } from "../data/falcilar";
import { REMIL_FIGURLER, REMIL_TOKEN_BEDELI, REMIL_ACILIM_POZISYONLARI } from "../data/remilFigurler";

const KATEGORILER = [
  { id: "ask", emoji: "❤️", isim: "Aşk & İlişkiler" },
  { id: "is", emoji: "💼", isim: "İş & Kariyer" },
  { id: "para", emoji: "💰", isim: "Para & Maddi Konular" },
  { id: "gelecek", emoji: "🔮", isim: "Gelecek" },
  { id: "genel", emoji: "🌙", isim: "Genel" },
  { id: "soru", emoji: "❓", isim: "Aklımdaki Soru" },
];

const REMIL_FALCILARI = FALCILAR.filter(f => ["mediha", "leyla", "ahmet"].includes(f.id));

function remilUret() {
  const acilim = REMIL_ACILIM_POZISYONLARI.map(poz => ({
    pozisyon: poz.isim,
    pozisyonAciklama: poz.aciklama,
    figur: REMIL_FIGURLER[Math.floor(Math.random() * 16)],
  }));
  return acilim;
}

function FigurSembol({ pattern, boyut = 14 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3, alignItems: "center" }}>
      {pattern.map((tip, i) => (
        <div key={i} style={{ display: "flex", gap: 4 }}>
          {tip === "tek" ? (
            <div style={{ width: boyut, height: boyut, borderRadius: "50%", background: "#C9A84C", boxShadow: "0 0 6px rgba(201,168,76,0.6)" }} />
          ) : (
            <>
              <div style={{ width: boyut, height: boyut, borderRadius: "50%", background: "#C9A84C", boxShadow: "0 0 6px rgba(201,168,76,0.6)" }} />
              <div style={{ width: boyut, height: boyut, borderRadius: "50%", background: "#C9A84C", boxShadow: "0 0 6px rgba(201,168,76,0.6)" }} />
            </>
          )}
        </div>
      ))}
    </div>
  );
}

function KumAnimasyonu({ onTamamlandi }) {
  const canvasRef = useRef(null);
  const [dokunuldu, setDokunuldu] = useState(false);
  const [tamamlandi, setTamamlandi] = useState(false);
  const parcaciklar = useRef([]);
  const animRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    function ciz() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      parcaciklar.current.forEach((p, i) => {
        p.y += p.vy;
        p.x += p.vx;
        p.vy += 0.05;
        p.opacity -= 0.008;
        if (p.opacity <= 0) parcaciklar.current.splice(i, 1);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201, 168, 76, ${p.opacity})`;
        ctx.fill();
      });
      animRef.current = requestAnimationFrame(ciz);
    }
    ciz();
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  const dokunmaIsle = (e) => {
    if (tamamlandi) return;
    setDokunuldu(true);
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.touches?.[0]?.clientX || e.clientX) - rect.left;
    const y = (e.touches?.[0]?.clientY || e.clientY) - rect.top;

    for (let i = 0; i < 20; i++) {
      parcaciklar.current.push({
        x, y,
        vx: (Math.random() - 0.5) * 4,
        vy: (Math.random() - 0.5) * 4 - 2,
        r: Math.random() * 3 + 1,
        opacity: 1,
      });
    }

    if (!tamamlandi) {
      setTimeout(() => {
        setTamamlandi(true);
        onTamamlandi();
      }, 2000);
    }
  };

  return (
    <div style={{ position: "relative", borderRadius: 20, overflow: "hidden", border: "1px solid rgba(201,168,76,0.3)", background: "rgba(20,15,5,0.8)" }}>
      <canvas
        ref={canvasRef}
        style={{ width: "100%", height: 220, display: "block", cursor: "pointer" }}
        onClick={dokunmaIsle}
        onTouchStart={dokunmaIsle}
        onTouchMove={dokunmaIsle}
      />
      <div style={{
        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
        textAlign: "center", pointerEvents: "none",
        opacity: dokunuldu ? 0 : 1, transition: "opacity 0.5s",
      }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>🤲</div>
        <div style={{ fontSize: 14, color: "rgba(201,168,76,0.8)", fontWeight: 600 }}>Kuma dokun ve Remil'i oluştur</div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 4 }}>Ekrana dokunmaya devam et</div>
      </div>
      {tamamlandi && (
        <div style={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
          textAlign: "center",
        }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>✨</div>
          <div style={{ fontSize: 14, color: "#C9A84C", fontWeight: 600 }}>Remil oluşturuldu</div>
        </div>
      )}
    </div>
  );
}

export default function Remil() {
  const navigate = useNavigate();
  const { tokenBalance, user, harcaToken } = useToken();
  const [adim, setAdim] = useState(1);
  const [seciliKategori, setSeciliKategori] = useState(null);
  const [soru, setSoru] = useState("");
  const [seciliFalci, setSeciliFalci] = useState(null);
  const [acilim, setAcilim] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [yorum, setYorum] = useState("");
  const [hata, setHata] = useState("");
  const [falId, setFalId] = useState(null);

  const kumTamamlandi = () => {
    const yeniAcilim = remilUret();
    setAcilim(yeniAcilim);
    setTimeout(() => setAdim(4), 1500);
  };

  const yorumAl = async () => {
    if (!user) { navigate("/giris"); return; }
    if (tokenBalance < REMIL_TOKEN_BEDELI) { setHata(`Yeterli tokenin yok. En az ${REMIL_TOKEN_BEDELI} token gerekli.`); return; }

    setYukleniyor(true);
    setHata("");

    const tokenHarcandi = await harcaToken(REMIL_TOKEN_BEDELI, "remil");
    if (!tokenHarcandi) { setHata("Token harcama başarısız."); setYukleniyor(false); return; }

    try {
      const session = await supabase.auth.getSession();
      const token = session.data.session?.access_token;

      const { data, error } = await supabase.functions.invoke("remil-yorumu", {
        headers: { Authorization: `Bearer ${token}` },
        body: {
          falciId: seciliFalci.id,
          falciPrompt: seciliFalci.isim,
          kategori: KATEGORILER.find(k => k.id === seciliKategori)?.isim || seciliKategori,
          soru,
          acilim,
        },
      });

      if (error || !data?.success) throw new Error(data?.error || "Yorum alınamadı");

      setYorum(data.yorum);
      setFalId(data.falId);
      setAdim(5);
    } catch (err) {
      setHata(err.message);
      await harcaToken(-REMIL_TOKEN_BEDELI, "remil_iade");
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0805 0%, #1a1205 40%, #0d0a05 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes parlak { 0%,100% { opacity:0.6; } 50% { opacity:1; } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>
      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        {/* Header */}
        <div style={{ padding: "24px 20px 16px", display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => adim === 1 ? navigate(-1) : setAdim(adim - 1)}
            style={{ background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 12, width: 38, height: 38, color: "#C9A84C", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>‹</button>
          <div>
            <div style={{ fontSize: 20, fontWeight: 700, color: "#C9A84C", letterSpacing: 1 }}>Remil</div>
            <div style={{ fontSize: 11, color: "rgba(201,168,76,0.5)", letterSpacing: 1.5 }}>KADİM KUM FALI</div>
          </div>
          {user && (
            <div style={{ marginLeft: "auto", background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 20, padding: "6px 14px", fontSize: 13, color: "#C9A84C", fontWeight: 700 }}>
              🪙 {tokenBalance}
            </div>
          )}
        </div>

        {hata && (
          <div style={{ margin: "0 20px 16px", padding: "12px 16px", borderRadius: 12, background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#FCA5A5", fontSize: 13 }}>
            ⚠️ {hata}
          </div>
        )}

        {/* ADIM 1 — Ana Sayfa */}
        {adim === 1 && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ fontSize: 64, marginBottom: 12, animation: "parlak 3s ease-in-out infinite" }}>◆</div>
              <div style={{ fontSize: 15, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 8 }}>
                Aklındaki soruyu belirle.<br />Kumun üzerinde oluşan sembolleri birlikte yorumlayalım.
              </div>
              <div style={{ fontSize: 12, color: "rgba(201,168,76,0.6)" }}>🪙 {REMIL_TOKEN_BEDELI} token</div>
            </div>

            <button onClick={() => setAdim(2)}
              style={{ width: "100%", padding: "16px", borderRadius: 16, background: "linear-gradient(135deg, #5a3a00, #C9A84C)", border: "none", color: "#000", fontSize: 16, fontWeight: 800, cursor: "pointer", marginBottom: 16 }}>
              ✦ Remil Falına Başla
            </button>

            <button onClick={() => navigate("/remil-nedir")}
              style={{ width: "100%", padding: "12px", borderRadius: 14, background: "transparent", border: "1px solid rgba(201,168,76,0.3)", color: "rgba(201,168,76,0.7)", fontSize: 13, cursor: "pointer" }}>
              Remil Nedir?
            </button>

            {/* 16 Şekil Önizleme */}
            <div style={{ marginTop: 32 }}>
              <div style={{ fontSize: 11, color: "rgba(201,168,76,0.5)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 16, textAlign: "center" }}>16 Remil Şekli</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
                {REMIL_FIGURLER.map(f => (
                  <div key={f.id} style={{ background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 12, padding: "10px 6px", textAlign: "center" }}>
                    <FigurSembol pattern={f.pattern} boyut={8} />
                    <div style={{ fontSize: 9, color: "rgba(201,168,76,0.6)", marginTop: 6 }}>{f.isim}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ADIM 2 — Falcı Seçimi */}
        {adim === 2 && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#C9A84C", marginBottom: 6 }}>Falcını Seç</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 20 }}>Remil'ini kim yorumlasın?</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {REMIL_FALCILARI.map(f => (
                <div key={f.id} onClick={() => { setSeciliFalci(f); setAdim(3); }}
                  style={{ borderRadius: 16, background: seciliFalci?.id === f.id ? `${f.renk}44` : "rgba(201,168,76,0.05)", border: `1px solid ${seciliFalci?.id === f.id ? f.parlak : "rgba(201,168,76,0.2)"}`, padding: "16px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }}>
                  <div style={{ fontSize: 36 }}>{f.emoji}</div>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>{f.isim}</div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>{f.uzmanlik}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ADIM 3 — Niyet & Soru */}
        {adim === 3 && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#C9A84C", marginBottom: 6 }}>Niyetini Belirle</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 20 }}>Remil falına başlamadan önce aklındaki konuyu belirle</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
              {KATEGORILER.map(k => (
                <div key={k.id} onClick={() => setSeciliKategori(k.id)}
                  style={{ borderRadius: 14, background: seciliKategori === k.id ? "rgba(201,168,76,0.2)" : "rgba(201,168,76,0.05)", border: `1px solid ${seciliKategori === k.id ? "rgba(201,168,76,0.6)" : "rgba(201,168,76,0.15)"}`, padding: "14px 10px", textAlign: "center", cursor: "pointer" }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>{k.emoji}</div>
                  <div style={{ fontSize: 11, color: seciliKategori === k.id ? "#C9A84C" : "rgba(255,255,255,0.6)", fontWeight: 600 }}>{k.isim}</div>
                </div>
              ))}
            </div>
            {seciliKategori === "soru" && (
              <textarea value={soru} onChange={e => setSoru(e.target.value)}
                placeholder="Sorunuzu kısaca yazın..." rows={3}
                style={{ width: "100%", background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.2)", borderRadius: 12, padding: "12px 14px", color: "#fff", fontSize: 14, resize: "none", fontFamily: "'Trebuchet MS', sans-serif", marginBottom: 16 }} />
            )}
            <button onClick={() => seciliKategori && setAdim(4)}
              disabled={!seciliKategori}
              style={{ width: "100%", padding: "15px", borderRadius: 14, background: seciliKategori ? "linear-gradient(135deg, #5a3a00, #C9A84C)" : "rgba(255,255,255,0.08)", border: "none", color: seciliKategori ? "#000" : "rgba(255,255,255,0.3)", fontSize: 15, fontWeight: 700, cursor: seciliKategori ? "pointer" : "default" }}>
              Devam Et →
            </button>
          </div>
        )}

        {/* ADIM 4 — Kum Animasyonu */}
        {adim === 4 && !acilim && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#C9A84C", marginBottom: 6 }}>Remil'ini Oluştur</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 20 }}>Ekrana dokunarak Remil'ini oluştur</div>
            <KumAnimasyonu onTamamlandi={kumTamamlandi} />
          </div>
        )}

        {/* ADIM 4 — Açılım Gösterimi */}
        {adim === 4 && acilim && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#C9A84C", marginBottom: 6 }}>Remil Açılımın</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 20 }}>7 pozisyonlu açılımın hazır</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 24 }}>
              {acilim.map((poz, i) => (
                <div key={i} style={{ borderRadius: 14, background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.15)", padding: "14px 16px", display: "flex", alignItems: "center", gap: 14, animation: "kart-gir 0.5s ease backwards", animationDelay: `${i * 80}ms` }}>
                  <FigurSembol pattern={poz.figur.pattern} boyut={10} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 10, color: "rgba(201,168,76,0.5)", letterSpacing: 1, marginBottom: 2 }}>{poz.pozisyon}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#C9A84C" }}>{poz.figur.isim}</div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 2 }}>{poz.figur.anaTemalar.slice(0, 2).join(" · ")}</div>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={yorumAl} disabled={yukleniyor}
              style={{ width: "100%", padding: "16px", borderRadius: 16, background: yukleniyor ? "rgba(201,168,76,0.2)" : "linear-gradient(135deg, #5a3a00, #C9A84C)", border: "none", color: yukleniyor ? "rgba(255,255,255,0.4)" : "#000", fontSize: 16, fontWeight: 800, cursor: yukleniyor ? "default" : "pointer" }}>
              {yukleniyor ? "🔮 Yorumlanıyor..." : `✦ Remil'i Yorumla — 🪙 ${REMIL_TOKEN_BEDELI}`}
            </button>
          </div>
        )}

        {/* ADIM 5 — Yorum */}
        {adim === 5 && yorum && (
          <div style={{ padding: "0 20px", animation: "kart-gir 0.5s ease" }}>
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <div style={{ fontSize: 48, marginBottom: 8 }}>◆</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: "#C9A84C" }}>{seciliFalci?.isim}</div>
              <div style={{ fontSize: 12, color: "rgba(201,168,76,0.5)", marginTop: 2 }}>Remil Yorumu</div>
            </div>
            <div style={{ background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 16, padding: "20px", marginBottom: 20, fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.8, whiteSpace: "pre-wrap" }}>
              {yorum.replace(/##\s/g, "").replace(/\*\*/g, "").replace(/\*/g, "")}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <button onClick={() => navigate("/fallarim")}
                style={{ width: "100%", padding: "14px", borderRadius: 14, background: "linear-gradient(135deg, #5a3a00, #C9A84C)", border: "none", color: "#000", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                Fallarıma Git
              </button>
              <button onClick={() => { setAdim(1); setAcilim(null); setYorum(""); setSeciliKategori(null); setSoru(""); }}
                style={{ width: "100%", padding: "12px", borderRadius: 14, background: "transparent", border: "1px solid rgba(201,168,76,0.2)", color: "rgba(201,168,76,0.6)", fontSize: 13, cursor: "pointer" }}>
                Yeni Remil
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
